import React from "react";

export default function WorldSectionLayout({
  title,
  instructions,
  points = 1,
  children
}) {
  return (
    <div style={styles.section}>
      {/* ───────── SECTION HEADER (QuestionLayout-style grid) ───────── */}
      <div style={styles.headerGrid}>
        <div style={styles.headerMain}>
          <div style={styles.title}>
            {title}
          </div>

          {instructions && (
            <div style={styles.instructions}>
              {instructions}
            </div>
          )}
        </div>

        {/* spacer column (matches legend slot) */}
        <div />

        {/* points box (identical look) */}
        <div style={styles.points}>
          {points}
        </div>
      </div>

      {/* ───────── QUESTIONS ───────── */}
      <div style={styles.questions}>
        {children}
      </div>
    </div>
  );
}

/* ───────────────────── STYLES ───────────────────── */

const styles = {
  section: {
    marginBottom: 40,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0
  },

  /* matches QuestionLayout container */
  headerGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 220px 70px",
    gap: "16px",
    alignItems: "start",
    marginBottom: 16,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0
  },

  headerMain: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0
  },

  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: 4
  },

  instructions: {
    fontWeight: "bold",
    lineHeight: 1.4
  },

  questions: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0
  },

  /* copied exactly from QuestionLayout */
  points: {
    border: "2px solid #333",
    textAlign: "center",
    fontSize: "18px",
    height: "30px",
    width: "30px",
    lineHeight: "30px",
    justifySelf: "center"
  }
};
